<template>
  <div class="list">
    <van-nav-bar
      :title="'考试任务('+list.length+')'"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <van-empty v-if="list.length==0" description="暂无考试任务" />
    <van-loading style="text-align: center" type="spinner" v-if="loading" color="#1989fa" />
    <van-row v-for="(item,index) in list" :key="index" class="xitem"   justify="space-between">
      <van-col span="18">
        <h4>{{ item.paperDesc }} {{ `(${item.skrs}人)` }}</h4>
        <p>课程名称：{{ item.kcmc }}</p>
        <p>考试班级：{{ item.hbmc }}</p>
        <p>领取状态：{{ item.paperlq != '已领取'?'未领取':item.paperlq }}</p>
      </van-col>

      <van-col span="24">
        <div
          class="enter"
          @click="enterTest(item.taskid,item.paperlq)"
        >领取<van-icon name="arrow" />
        </div>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        list: [],
        loading:true,
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          orderColumn:undefined,
          orderState:undefined,
          xnxq: null,
          kcmc: null,
          paperDesc:null,
        },
      }
    },
    created() {
      this.getxnxq();
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      enterTest(id,paperlq) {
        if(paperlq == '已领取'){
          this.$toast.fail('已领取过了');
          return;
        }
        let that = this;
        this.$dialog.confirm({
          title: "试卷领取",
          message: "确定要领取吗？",
          messageAlign: 'center'
        }).then(() => {
          let data = {taskid:id};
          that.$ajax.put('/teacher/paperlq/updatepaperlq',data).then(function (res) {
            if (res.code == 200) {
              that.$toast.success('领取成功');
              that.getjkrw();
            }
          })
        }).catch(()=>{

        })
      },
      getxnxq() {
        let that = this;
        this.$ajax.get('/teacher/suitang/xnxq').then(function (res) {
          that.queryParams.xnxq =  res.data.xnxq;
          that.getjkrw();
        })
      },
      getjkrw() {
        let that = this;
        let data = {params:that.queryParams}
        this.$ajax.get('/teacher/paperlq/listtask',data).then(function (res) {
          if (res.code == 200) {
            that.list = res.rows;
            that.loading = false;
          }
        })
      },
    }
  }
</script>
<style lang="scss" scoped>
  .list{
    margin-top: 4.125rem;
    padding: 0 1.25rem;
    .xitem{
      background-color: #F8F8F8;
      margin-bottom: .9375rem;
      border-radius: 5px;
      padding: .9375rem 1.25rem;
      h4{
        margin: 0;
        line-height: 1.375rem;
        margin-bottom: .5rem;
      }
      p{
        color: #757DA3;
        font-size: .75rem;
        margin: 0;
        margin-top: .125rem;
        line-height: 1.0625rem;
      }
      .enter{
        color: #757DA3;
        display: flex;
        font-size: .875rem;
        justify-content: space-between;
        padding-top: .9375rem;
        margin-top: .625rem;
        position: relative;
        &::after{
          position: absolute;
          width: calc(100% + 2.5rem);
          left: -1.25rem;
          top: 0;
          content: '';
          height: 1px;
          background-color: #EBEBEB;
        }
      }
      span{
        font-size: .75rem;
        &.ing{
          color: #F86969;
        }
        &.end{
          color: #7469F8;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/paperlq.vue